<template>
  <div>
            <!-- Breadcrumb Section Begin -->
      <div class="breacrumb-section" v-if="detalhe!=''">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-text">
                      <router-link to="/"><i class="fa fa-home"></i> {{ $t('nav.home') }}</router-link>
                        <span>{{ $localeField(detalhe, 'itiNome') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="blog-details spad" v-if="detalhe!=''">
        <div class="container">
            <div class="row">
              <div style="text-align:center;">
                <router-link to="/blog" style="float:right; color:#0056b3;">{{ $t('blog.back') }}</router-link>
               </div>
                <div class="col-lg-12">
                    <div class="blog-details-inner">
                        <div class="blog-detail-title">
                            <h2>{{ $localeField(detalhe, 'itiNome') }}</h2>
                            <p><span>{{  formattedDate(detalhe.itiData1) }}</span></p>
                        </div>
                        <p v-html="$localeHtml(detalhe, 'itiResumo1')"></p>
                        <div class="blog-more" v-if="detalhe.insInstitucionalImagens!=''">
                            <div class="row" style="justify-content: center;">
                                <div class="col-sm-8">
                                    <img :src="$imgURL + detalhe.insInstitucionalImagens[0].itgUrlImagem"  alt="">
                                </div>
                            </div>
                        </div>
                        <p v-html="$localeHtml(detalhe, 'itiResumo2')"></p>
                        <div class="tag-share" style="display: none;">
                            <div class="blog-share">
                                <span>{{ $t('blog.share') }}:</span>
                                <div class="social-links">
                                    <a href="#"><i class="fa fa-facebook"></i></a>
                                    <a href="#"><i class="fa fa-twitter"></i></a>
                                    <a href="#"><i class="fa fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Blog Details Section End -->
  </div>
</template>

<script>
//import moment from 'moment'
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import axios from 'axios';

export default {
  name: '/BlogDetalheView',
  components: {
  },
  setup() {
        const route = useRoute();
        const id = route.params.id;
        const nomeProduto = route.params.nome;
        return {
            id
        };
    },
  data: () => ({
    detalhe:[],
  }),
  methods: {
    carregaMetas(titlenews,value) {
			useHead({
				title: titlenews + ' - Blog Detalhe - Sub4 Turismo',
        meta: [
          { name: "description", content: value },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" }, 
          { charset: "UTF-8" }, 
          { name: "robots", content: "index, follow" }, 
        ],
			})
    },
    formattedDate(value) {
      return this.$moment(value).format('DD [de] MMMM [de] YYYY');
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
  },
  },
  async created() { 

      axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
          this.detalhe = response.data
          this.carregaMetas(this.$localeField(this.detalhe, 'itiNome'), this.removerTagsHTML(this.$localeHtml(this.detalhe, 'itiResumo1')));
          //console.log('this.detalhe')
          //console.log(this.detalhe)
      })
      .catch(error => {
          console.error(error);
      });
  },
}
</script>

<style>
p p {
  text-align: justify;
}

p p a {
  color:#0056b3 !important;
}

</style>
